import React from 'react'

import styles from './footer.module.css'

const Footer = () => (
  <footer className={styles.demoFooter}>
    <p className={styles.demoFooterContent}>Made by David Dunn</p>
    <p className={styles.demoFooterContent}><a className={styles.demoFooterContent} href={"https://twitter.com/dd4dev"}>@dd4dev</a></p>
  </footer>
)

export default Footer